/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Add_ReactionsInputs */



/**
* | output |
* | --- |
* | "Add Reactions" |
*
* @param {Leveling_Perm_Add_ReactionsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_add_reactions = /** @type {((inputs?: Leveling_Perm_Add_ReactionsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Add_ReactionsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавлять реакции")
	return /** @type {LocalizedString} */ ("Add Reactions")
});